document.addEventListener("DOMContentLoaded", function () {
  const carouselWrapper = document.querySelector(".carousel-wrapper");
  const slideContainer = carouselWrapper.querySelector(".carousel-slides");
  const slides = carouselWrapper.querySelectorAll(".carousel-slide");
  const leftArrow = carouselWrapper.querySelector(".arrow-left"); 
  const rightArrow = carouselWrapper.querySelector(".arrow-right");

  function getSlideWidth(){
    return slides[0].offsetWidth + 16
  }

  function next(){
    if (currentIndex == totalSlides) return
      if (currentIndex >= totalSlides - 1) {
        leftArrow.classList.add('disable-arrows');
      }
      if (rightArrow.classList.contains('disable-arrows')) {
        rightArrow.classList.remove('disable-arrows')
      }

      currentIndex += 1
      dist += WIDTH;
      slideContainer.style.transform = `translateX(-${dist}px)`;
  }
  function prev(){
    if (currentIndex == 1) return
      if (currentIndex <= 2) {
        rightArrow.classList.add("disable-arrows")
      }
      if (leftArrow.classList.contains("disable-arrows")){
        leftArrow.classList.remove("disable-arrows")
      }
      currentIndex -= 1
      dist = dist - WIDTH;
      slideContainer.style.transform = `translateX(-${dist}px)`
  }
  
  const MAXSLIDES = slides.length
  const SLIDECONTAINERWIDTH = slideContainer.offsetWidth
  const THRESHOLD = 100;
  const WIDTH = getSlideWidth()
  let currentIndex = 1;
  let dist = 0
  let totalSlides = 0 

  let touchStartX = 0;
  let touchEndX = 0;
  let isDragging = false;
  const MIN_SWIPE_DIST = 100;

  if (SLIDECONTAINERWIDTH - WIDTH > 100) {
    totalSlides = MAXSLIDES - 1
  } else {
    totalSlides = MAXSLIDES
  }

  rightArrow.classList.add("disable-arrows")
  if (leftArrow) {
    
    leftArrow.addEventListener('click', next)
  }

  if (rightArrow) {
    rightArrow.addEventListener('click', prev)
  }
  
});
